/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebSealUserInfoResponseViewModel
 */
export interface WebSealUserInfoResponseViewModel {
    /**
     * 
     * @type {string}
     * @memberof WebSealUserInfoResponseViewModel
     */
    sub: string;
    /**
     * 
     * @type {string}
     * @memberof WebSealUserInfoResponseViewModel
     */
    givenName: string;
    /**
     * 
     * @type {string}
     * @memberof WebSealUserInfoResponseViewModel
     */
    familyName: string;
    /**
     * 
     * @type {string}
     * @memberof WebSealUserInfoResponseViewModel
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof WebSealUserInfoResponseViewModel
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof WebSealUserInfoResponseViewModel
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof WebSealUserInfoResponseViewModel
     */
    intermediaryCode: string;
}

/**
 * Check if a given object implements the WebSealUserInfoResponseViewModel interface.
 */
export function instanceOfWebSealUserInfoResponseViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sub" in value;
    isInstance = isInstance && "givenName" in value;
    isInstance = isInstance && "familyName" in value;
    isInstance = isInstance && "displayName" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "intermediaryCode" in value;

    return isInstance;
}

export function WebSealUserInfoResponseViewModelFromJSON(json: any): WebSealUserInfoResponseViewModel {
    return WebSealUserInfoResponseViewModelFromJSONTyped(json, false);
}

export function WebSealUserInfoResponseViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebSealUserInfoResponseViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sub': json['sub'],
        'givenName': json['given_name'],
        'familyName': json['family_name'],
        'displayName': json['display_name'],
        'name': json['name'],
        'email': json['email'],
        'intermediaryCode': json['intermediaryCode'],
    };
}

export function WebSealUserInfoResponseViewModelToJSON(value?: WebSealUserInfoResponseViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sub': value.sub,
        'given_name': value.givenName,
        'family_name': value.familyName,
        'display_name': value.displayName,
        'name': value.name,
        'email': value.email,
        'intermediaryCode': value.intermediaryCode,
    };
}

